<template>
  <div class="summary">
    <div class="item">
      <div class="text evidence">
        {{ $t('amount') }} {{ getSettings.currencySymbol }}
      </div>
      <div class="value">
        <input
          autocomplete="off"
          v-model.number="getBet._multiple_detail.amount"
          type="number"
          step="0.50"
          min="0"
          @input="verifyAmount(getBet._multiple_detail.amount), refreshCart()"
          id="amount"
        />
      </div>
    </div>

    <div
      class="item container_btn_add_amount"
      v-if="getSettings.enableButtonsCart"
    >
      <v-btn
        class="btn_add_amount_cart"
        px-1
        py-1
        v-for="(buttonCart, index) in getSettings.buttonsCart"
        :key="index"
        @click="addAmountBet(buttonCart.value)"
      >
        +{{ buttonCart.value }} {{ getSettings.currencySymbol }}
      </v-btn>
    </div>

    <div class="item" v-if="getSettings.sm_multiplicity">
      <div class="text">{{ $t('multiplicity') }}</div>
      <div class="value">{{ getBet._multiple_detail.multiplicity }}</div>
    </div>

    <div
      class="item"
      v-if="
        getSettings.sm_bonus && +getBet._multiple_detail.bonus_percentage > 0
      "
    >
      <div class="text">{{ $t('bonus') }}</div>
      <div class="value">% {{ getBet._multiple_detail.bonus_percentage }}</div>
    </div>

    <div class="item" v-if="getSettings.sm_odds_total">
      <div class="text">{{ $t('odds') }}</div>
      <div class="value">
        x
        {{
          getBet._multiple_detail.odds_total
            | round_digits(2)
            | odds_type_filter
        }}
      </div>
    </div>
    <div class="item" v-if="getSettings.sm_winning">
      <div class="text">{{ $t('winning') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._multiple_detail.winning) }}
      </div>
    </div>
    <div
      class="item"
      v-if="getSettings.sm_bonus_total && +getBet._multiple_detail.bonus > 0"
    >
      <div class="text">{{ $t('bonus') }} {{ $t('total') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._multiple_detail.bonus) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.sm_profit">
      <div class="text">{{ $t('profit') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._multiple_detail.profit) }}
      </div>
    </div>
    <div class="item" v-if="getSettings.sm_winning_total">
      <div class="text">{{ $t('winning') }} {{ $t('total') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._multiple_detail.winning_total) }}
      </div>
    </div>

    <template v-if="getPercentageTaxValueOnWon > 0">
      <div class="item">
        <div class="text">{{ $t('percentageTaxValueOnWon') }}</div>
        <div class="value">{{ getPercentageTaxValueOnWon + ' %' }}</div>
      </div>

      <div
        class="item"
        v-if="getBet._multiple_detail.expectedTotalTaxedWinnings"
      >
        <div class="text">{{ $t('expected_winning_total_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._multiple_detail.expectedTotalTaxedWinnings) }}
        </div>
      </div>

      <div class="item">
        <div class="text">{{ $t('expectedProfitTaxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._multiple_detail.expectedProfitTaxed) }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly } from 'mobile-device-detect'

export default {
  name: 'SummarySingleMultiple',
  data: () => ({}),
  mounted() {
    this.$root.$on('forceUpdateSingleMultiple', () => {
      this.forceUpdateSummaryMultiple()
    })
  },
  computed: {
    ...mapGetters({
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
      getPercentageTaxValueOnWon: 'settings/getPercentageTaxValueOnWon',
    }),
  },
  methods: {
    ...mapActions({
      refreshCart: 'cart/refreshCart',
    }),

    forceUpdateSummaryMultiple() {
      this.$forceUpdate()
    },
    async verifyAmount(amount) {
      if (amount < 0) {
        this.getBet._multiple_detail.amount = 0
        await this.$store.dispatch('cart/refreshCart')
      }
    },
    addAmountBet(amount) {
      if (amount != undefined && +amount > 0.0) {
        this.getBet._multiple_detail.amount += +amount
        this.refreshCart()
      }
    },
    formatNumber(amount) {
      const numberFormatted = new Intl.NumberFormat().format(amount)

      return numberFormatted
    },
  },
}
</script>
